import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import {
  NORMAL_MON_TO_FRI,
  NORMAL_DAYS_OF_WEEKEND,
  NORMAL_EXCEPT_WEEKEND,
} from 'configs/localData';
import { Row, Col, Checkbox } from 'antd';
import i18next from 'i18next';

import { responsiveColHour } from '../utils';
import CardHour from '../CardHour';

const NormalHourForm = ({ openTime, isDifferent, isEdit }) => {
  const [different, setDifferent] = useState(isDifferent);

  const onChange = (e) => {
    setDifferent(e.target.checked);
  };

  useEffect(() => {
    setDifferent(isDifferent);
  }, [isDifferent]);

  return (
    <div className="hour-section">
      {isEdit && (
        <Checkbox
          onChange={onChange}
          checked={different}
          className="hour-section__checkbox-different"
        >
          <span className="hour-section__checkbox-different__bold">
            {i18next.t('daysOfWeek.different')}
          </span>{' '}
          <span className="hour-section__checkbox-different__light">
            {i18next.t('daysOfWeek.descriptionDifferent')}
          </span>
        </Checkbox>
      )}
      <Row gutter={[24, 24]} style={{ marginBottom: 20 }}>
        {different ? (
          NORMAL_EXCEPT_WEEKEND.map((obj) => (
            <Col {...responsiveColHour} key={obj.value}>
              <CardHour
                isEdit={isEdit}
                itemConst={obj}
                item={openTime?.[obj.value]}
              />
            </Col>
          ))
        ) : (
          <Col {...responsiveColHour}>
            <CardHour
              isEdit={isEdit}
              item={openTime?.[NORMAL_MON_TO_FRI.valueMap]}
              itemConst={NORMAL_MON_TO_FRI}
            />
          </Col>
        )}
        {NORMAL_DAYS_OF_WEEKEND.map((obj) => (
          <Col {...responsiveColHour} key={obj.value}>
            <CardHour
              isEdit={isEdit}
              itemConst={obj}
              item={openTime?.[obj.value]}
            />
          </Col>
        ))}
      </Row>
    </div>
  );
};

NormalHourForm.propTypes = {
  openTime: PropTypes.object,
  isDifferent: PropTypes.bool,
  isEdit: PropTypes.bool,
};

NormalHourForm.defaultProps = {
  openTime: {},
};

export default NormalHourForm;
